const SixImagePhotoGallery = ({ data }) => {
  if (!data || !data.gallery_images || data.gallery_images.length === 0) {
    return (
      <div className="six-image-gallery">
        <div className="gallery-header">
          <h1 className="gallery-title">No Images Available</h1>
        </div>
      </div>
    );
  }

  const images = data.gallery_images.slice(0, 6);

  return (
    <div className="six-image-gallery">
      <div className="gallery-header">
        <h2 className="top-header">{data.title}</h2>
        <div className="header-divider"></div>
      </div>

      <div className="gallery-alternating">
        <div className="gallery-row two-images">
          {images.slice(0, 2).map((image) => (
            <div key={image.id} className="gallery-item-half">
              <img 
                src={image.url} 
                alt={`Image ${image.id}`}
                className="gallery-image"
              />
            </div>
          ))}
        </div>

        {images[2] && (
          <div className="gallery-row one-image">
            <div className="gallery-item-full">
              <img 
                src={images[2].url} 
                alt="Image 3"
                className="gallery-image"
              />
            </div>
          </div>
        )}

        {images[3] && images[4] && (
          <div className="gallery-row two-images">
            {images.slice(3, 5).map((image) => (
              <div key={image.id} className="gallery-item-half">
                <img 
                  src={image.url} 
                  alt={`Image ${image.id}`}
                  className="gallery-image"
                />
              </div>
            ))}
          </div>
        )}

        {images[5] && (
          <div className="gallery-row one-image">
            <div className="gallery-item-full">
              <img 
                src={images[5].url} 
                alt="Image 6"
                className="gallery-image"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SixImagePhotoGallery;